<template>
  <div class="file_preview">
    <Modal v-model="modal1" fullscreen title="文件" :value="true">
      <iframe v-if="!modal2" style="width: 100%;height:94vh;" :src="file_data" frameborder="0"></iframe>
      <template v-else>
        <video v-if="filetype == 'video'" ref="videoPlayer" :src="file_data" controls="controls"
               poster="@/assets/images/aqitai.svg" preload="auto" style="width: 100%;height: 100%">
          您的浏览器不支持当前播放器播放。
        </video>
        <audio v-if="filetype == 'audio'" ref="audioPlayer" :src="file_data" controls="controls"
               controlslist="nodownload"
               style="position: absolute;left: calc(calc(100% - 300px) / 2);top: calc(calc(100% - 54px) / 2);">
          播放器不支持该格式音频
        </audio>
      </template>


      <div slot="footer">
        <Button type="primary" @click="modal1=false">{{ $t('m.cancel') }}</Button>
      </div>
    </Modal>
    <Button class="button" size="small" type="success" @click="preview()">{{ text ? text : '预览' }}</Button>

  </div>
</template>
<script>
export default {
  props: {
    file_name: {
      type: [Array, String],
      default: ''
    },
    text: {
      type: [String],
      default: ''
    },
    resourcesId: {
      type: [String, Number],
      default: ''
    },
    isResourcesId: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      modal2: false,
      modal1: false,
      file_data: '',
      filetype: ''
    }
  },
  methods: {
    preview() {
      // let name = this.file_name

      let file_arr = this.file_name.split('?')
      let name = file_arr && file_arr.length ? file_arr[0] : this.file_name

      let suffix = ''
      let result = ''
      try {
        var flieArr = name.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      var wordlist = ['zip', 'rar'];
      result = wordlist.some(function (item) {
        return item == suffix;
      });

      if (result) {
        this.$Message.error('不支持该格式预览!!!');
        return
      }

      // 匹配 文件名
      var wordlist = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
      result = wordlist.some(function (item) {
        return item == suffix;
      });
      var filelist = ['mp3', 'mp4', 'mov', 'MP3', 'MP4', 'MOV'];
      var result1 = filelist.some(function (item) {
        return item == suffix;
      });
      if (result) {
        // this.file_data = ''
        this.modal2 = false
        this.file_data = 'http://view.officeapps.live.com/op/view.aspx?src=' + this.file_name
        this.modal1 = true
      } else if (result1) {
        this.file_data = this.file_name
        // this.modal2 = false
        if (suffix == 'mp3' || suffix == 'MP3') {
          this.modal2 = true
          this.filetype = 'audio'
        } else {
          this.modal2 = true
          this.filetype = 'video'
        }
        this.modal1 = true
      } else {
        this.modal2 = false
        this.file_data = '/static/pdf/web/viewer.html?file=' + this.file_name
        this.modal1 = true
      }


      if (this.isResourcesId) {
        // this.$store.dispatch('saveUserBehavior', {
        //   path: this.$route.path,
        //   name: '资源预览',
        //   other_id: this.resourcesId,
        //   type: 2,
        // }).then(() => {
        // })
      }


    },
  },
  mounted() {
  },
  watch: {
    modal1: function (val) {
      if (!val) {
        if (this.$refs.audioPlayer) {
          this.$refs.audioPlayer.pause();
        }
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
        }
      }
    },
  },
  created() {
  }
}
</script>
<style lang="less">
.file_preview {
  .dis {
    margin: 5px 0;
    display: flex;
    justify-content: space-between;
  }

  .button {
    margin: 0 5px;
    white-space: break-spaces;

  }

  .modal {
    width: 700px;

  }

}

</style>


